import { isImmutable } from "immutable";
import isFunction from "lodash/isFunction";

/**
 * Make all function parameters toJS if they are immutable
 */
const paramFromImmutable = param => (isImmutable(param) ? param.toJS() : param);

const fnParamsFromImmutable = (fn, key) => {
  if (fn) {
    if (!isFunction(fn)) throw new Error(`Mapper.${key} must be a function`);

    return (...params) => fn(...params.map(paramFromImmutable));
  }

  return undefined;
};

export default class Mapper {
  constructor({ initial, from, to, ...rest }) {
    this.to = fnParamsFromImmutable(to, "to");
    this.from = fnParamsFromImmutable(from, "from");
    this.initial = fnParamsFromImmutable(initial, "initial");

    Object.entries(rest).forEach(([key, mapperFn]) => {
      this[key] = fnParamsFromImmutable(mapperFn, key);
    });
  }
}
